import {
    SIGN_INFO, LOGIN_USER, SIGN_OUT_USER, SET_TYPE, SET_PAGE,
    FETCH_ACTIVITES, FETCH_TACHES, FETCH_OFFRES, FETCH_FORMULES, FETCH_ACCESSOIRES, FETCH_ARTICLES, FETCH_CODE_PROMOS, FETCH_CONFIGURATIONS,
    SET_SIDEBAR, SET_TOPBAR, SET_IP_ADDRESS, SET_LOADING, SET_FETCH, SET_FILTRAGE, TIME_START, TIMEOUT_ID, FETCH_ROOMS
} from './constants.js'


// AUTHENTIFICATION ACTIONS -------------------------------
export const signInformation = token => ({
    type: SIGN_INFO,
    payload: token
})

export const loginUser = user => ({
    type: LOGIN_USER,
    payload: user
});

export const signOutUser = () => ({
    type: SIGN_OUT_USER
});

export const setType = type => ({
    type: SET_TYPE,
    payload: type
});

export const setPage = type => ({
    type: SET_PAGE,
    payload: type
});

export const timeStartCounter = date => ({
    type: TIME_START,
    payload: date
})

export const setTimeoutId = id => ({
    type: TIMEOUT_ID,
    payload: id
})

// FETCH DATA ACTIONS -------------------------------------
export const fetchActivites = activites => ({
    type: FETCH_ACTIVITES,
    payload: activites
})

export const fetchOffres = offres => ({
    type: FETCH_OFFRES,
    payload: offres
})

export const fetchFormules = formules => ({
    type: FETCH_FORMULES,
    payload: formules
})

export const fetchAccessoires = accessoires => ({
    type: FETCH_ACCESSOIRES,
    payload: accessoires
})

export const fetchArticles = articles => ({
    type: FETCH_ARTICLES,
    payload: articles
})

export const fetchTaches = taches => ({
    type: FETCH_TACHES,
    payload: taches
})

export const fetchRooms = rooms => ({
    type: FETCH_ROOMS,
    payload: rooms
})

export const fetchCodePromos = codepromos => ({
    type: FETCH_CODE_PROMOS,
    payload: codepromos
})

export const fetchConfigurations = Configurations => ({
    type: FETCH_CONFIGURATIONS,
    payload: Configurations
})

// CONFIGURATION -------------------------------------------
export const setFiltrage = filtrage => ({
    type: SET_FILTRAGE,
    payload: filtrage
})
export const setFetch = fetch => ({
    type: SET_FETCH,
    payload: fetch
})
export const setLoading = loading => ({
    type: SET_LOADING,
    payload: loading
})
export const setSidebar = sidebar => ({
    type: SET_SIDEBAR,
    payload: sidebar
})
export const setTopbar = topbar => ({
    type: SET_TOPBAR,
    payload: topbar
})
export const setIpAddress = ip => ({
    type: SET_IP_ADDRESS,
    payload: ip
})
